import React from 'react';

type SchemaProps = {
    input: unknown;
};

export function serializeJsonLd(input: unknown): string {
    return JSON.stringify(input).replace(/</g, '\\u003c');
}

export const Schema: React.FC<SchemaProps> = (props) => {
    return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: serializeJsonLd(props.input) }} />;
};
